/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable */
import React, { useState, useEffect } from 'react'

import Header from './Header'
import HeaderOld from 'Lib/Header'
import Sticky from 'Lib/Sticky'
import {
  readCookie,
  getLanguageMeta,
  getQueryParams,
  isInDomain
} from 'AccountsUtils'

import { ViewContainer } from '../UnifiedLogin'
import { checkMobileDevice, checkUserLogin } from '../../utils/validator'

import useModal from './useModal'
import SupportHead from './supportHead'
import { SectionBlock } from '..'
import Cross from '../../icons/cross.svg'
import Info from '../../assets/svgs/info-outline.svg'
import './index.scss'
import {
  supportByTripId,
  getAbTestConfigPWA,
  getAuthenticated
} from '../../pages/Trips/trips.helper'
import { Login } from '../Login'
import { initializeClevertap } from '../../utils'
import Support_header from './Support_header/index'
 import PageLoader from 'Lib/Pageloader'
 import { deviceId } from '../../deviceIdUtils'
const SupportPWAPage = () => {
  const { isShowing, toggle } = useModal()
  const [tripId, setTripId] = useState(null)
  const [otp, setOTP] = useState(null)
  const [otpReceived, setOTPReceived] = useState(false)
  const [page, setPageName] = useState(null)
  const [otpError, setOtpError] = useState(false)
  const timerOn = true
  const { locale } = getLanguageMeta()
  const [unifiedChange, setUnifiedChanges] = useState(false)
  const [abLogin, setAbLogin] = useState('a')
  const [showFkSSO, setShowFkSSO] = useState('b')
  const [showFkSSOPwa, setShowFkSSOPwa] = useState('b') 
  const showUnifiedLogin = locale === 'IN' && unifiedChange

  const [showSnackBar, setShowSnackBar] = useState(false)
  const [snackMsg, setSnackMsg] = useState(null)
  const params = getQueryParams()
  const [visibilityCSS, setVisibilityCSS] = useState(true)
  const [loader,setLoader] = useState(false)

  useEffect(() => {
    deviceId()
  }, [])
  useEffect(() => {
    setTimeout(() => {
      setVisibilityCSS(false)
    }, 500)
    async function getAbData() {
      const response = await getAbTestConfigPWA()
      const { status: responseStatus, data: responseData } = response || {}
      if (response && responseStatus === 200 && responseData) {
        if (responseData.home_page !== 'a') {
          setUnifiedChanges(true)
        }
        if(responseData.show_fk_sso) {
          setShowFkSSO(responseData.show_fk_sso)
        }
        if(responseData.show_fk_sso_pwa) {
          setShowFkSSOPwa(responseData.show_fk_sso_pwa)
        }
        if(responseData?.login_init === 'a') {
          setAbLogin('a')
        }else{
          setAbLogin('b')
        }
      }
    }
    getAbData()
    initializeClevertap()
    async function getAuthenticatedApiResponse(){
      setLoader(true)
      const resp = await getAuthenticated()
      const { status } = resp
      if(status === 200) {
        // if (params.source === 'home' && params.isMobileApp === 'true') {
          window.location.href = '/accounts/tripslist'
          setLoader(false)
        // } 
      }
       else{
        //check for signout case is required or not
        window.localStorage.removeItem("ON_LOGIN_PUSH");
        window.location.href = '/signout'
      }
      }
    
    if (!checkMobileDevice()) {
      window.location.href = '/support'
    } else {
      if (checkUserLogin()){
        getAuthenticatedApiResponse()
    }
    }
  }, [])

  const textHandler = (e, name) => {
    if (name === 'tripId') {
      setTripId(e.target.value)
    }
    if (name === 'otp') {
      setOTP(e.target.value)
    }
    if (name === 'otp' && (otp && otp.length === 6)) {
      setOtpError(false)
    }
  }

  const timer = remaining => {
    let m = Math.floor(remaining / 60)
    let s = remaining % 60
    m = m < 10 ? `0${m}` : m
    s = s < 10 ? `0${s}` : s
    if (document.getElementById('timer')) {
      document.getElementById('timer').innerHTML = `${m}:${s}`
    }
    // eslint-disable-next-line no-param-reassign
    remaining -= 1

    if (remaining >= 0 && timerOn) {
      setTimeout(() => {
        timer(remaining)
      }, 1000)
      return
    }
    if (timerOn) {
      if (document.getElementById('timer')) {
        document.getElementById('timer').innerHTML = 'Resend OTP'
      }
    }
  }

  const resetHandler = e => {
    setTripId('')
    setOTPReceived(false)
    setOtpError(false)
    setOTP(null)
    setSnackMsg(null)
    setShowSnackBar(false)
  }

  const handleIsShowing = () => {
    setPageName('SIGNIN')
    toggle()
  }

  const btnHandler = (e, action) => {
    if (
      action.toLowerCase() === 'get otp' ||
      (action.toLowerCase() === 'resend otp' &&
        document.getElementById('timer') &&
        document.getElementById('timer').innerHTML.toLowerCase() ===
        'resend otp')
    ) {
      setSnackMsg(null)
      setOTP(null)
      supportByTripId(tripId).then(resp => {
        if (
          resp &&
          resp.status === 200 &&
          resp.smsResponse.status.toLowerCase() === 'success'
        ) {
          timer(60, timerOn, 'timer')
          setOTPReceived(true)
          setShowSnackBar(true)
          setSnackMsg(
            'OTP has been sent to your mobile number, Email and will expire in 3 mins.'
          )
          setTimeout(() => setShowSnackBar(false), 4000)
        } else if (resp && resp.status === 404) {
          setOTPReceived(false)
          setShowSnackBar(true)
          setSnackMsg('Please enter a valid Trip Id to get the OTP.')
          setTimeout(() => setShowSnackBar(false), 4000)
        } else if (resp && resp.status === 401) {
          setOTPReceived(false)
          setShowSnackBar(true)
          setSnackMsg('OTP request limit exceeded. Please try after sometimes')
          setTimeout(() => {
            setShowSnackBar(false)
          }, 4000)
        } else if (
          resp &&
          resp.status === 400 &&
          resp.data &&
          resp.data.message === 'DELETED_USER'
        ) {
          setShowSnackBar(true)
          setSnackMsg(
            'Please check the email associated with Cleartrip for trip details'
          )
          setTimeout(() => {
            setShowSnackBar(false)
          }, 4000)
        }
      })
    } else if (action.toLowerCase() === 'fetch trip') {
      supportByTripId(tripId, otp).then(resp => {
        if (
          resp &&
          resp.status === 200 &&
          resp.message.toLowerCase() === 'verified'
        ) {
          if (params.source === 'home' && params.isMobileApp === 'true') {
            window.location.href = `/accounts/trips/${tripId}?isMobileApp=true&source=home`
          } else {
            window.location.href = `/accounts/trips/${tripId}`
          }
        } else if (resp.status === 404) {
          setOtpError(true)
        } else if (resp.status === 500) {
          setOtpError(true)
          setSnackMsg('Something went wrong. Please Try Again')
        }
      })
    }
  }

  const signHandle = e => {
    setPageName('SIGNIN')
    toggle()
  }
  window.androidData = window?.MobileApp ? JSON.parse(window?.MobileApp?.getAppSpecificData()) : {}
  return (
    <React.Fragment>
     {checkUserLogin() && loader? <PageLoader title="Fetching Trip Details" message="Please wait while we load your trip details." />: <div
        style={{
          WebkitUserSelect: 'auto',
          userSelect: 'auto',
          display: visibilityCSS ? 'none' : ''
        }}
      >
        <Sticky>
          {params.source === 'home' && params.isMobileApp === 'true' ? (
            <Support_header />
          ) : (
            <If condition={isInDomain()}>
              <Header menu={true} />
              <Else />
              <HeaderOld menu={true} />
            </If>
          )}
        </Sticky>
        <div
          className="bg"
          style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
        >
          <SupportHead />
          <SectionBlock header="FETCH YOUR TRIPS BY TRIPID">
            <ul
              className="bg-white"
              style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
            >
              <li
                className="border-bottom-grey flex flex-between px-4"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <div
                  className="flex flex-1"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  {/* <select className="mobilePrefix b-none bg-white">
                  <option selected={true} value="+91">+91</option>
                </select> */}
                  <div className="pl13" />
                  <div
                    className="flex flex-1 flex-middle"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <input
                      className="h-48 b-none max-100 fs-15"
                      value={tripId}
                      placeholder="Enter Trip ID"
                      onChange={e => textHandler(e, 'tripId')}
                      maxLength="15"
                      disabled={otpReceived}
                    />
                  </div>
                </div>
                <div
                  className="flex flex-middle flex-center"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  <If condition={!otpReceived}>
                    {tripId != null && tripId.length > 0 && (
                      <div
                        onClick={e => {
                          btnHandler(e, otpReceived ? 'Fetch Trip' : 'Get OTP')
                        }}
                      >
                        <p
                          className={`f3 ${tripId ? 'c-secondary-500' : 'c-neutral-400'
                            }`}
                        >
                          Get OTP
                        </p>
                      </div>
                    )}
                    <Else />
                    <Cross
                      fill="#cccccc"
                      width="16px"
                      height="16px"
                      onClick={e => {
                        resetHandler(e)
                      }}
                    />
                  </If>
                </div>
              </li>
              <If condition={otpReceived}>
                <li
                  className="border-bottom-grey flex cursorPoi flex-between flex-middle px-4"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  <div
                    className="flex"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <div className="pl13" />
                    <div
                      className="flex flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <input
                        className="h-48 b-none max-100 input_box_otp fs-15"
                        type="text"
                        value={otp || ''}
                        disabled={!otpReceived}
                        // onInput={e => setInput(e.target.value, setOtp)}
                        onChange={e => textHandler(e, 'otp')}
                        placeholder="Enter the OTP received"
                        maxLength="6"
                        pattern="[0-9]*"
                      />
                    </div>
                  </div>
                  {
                    <div
                      className="flex flex-middle flex-center"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <div>
                        <p
                          id="timer"
                          className="f3 c-secondary-500"
                          onClick={e => {
                            btnHandler(e, 'Resend OTP')
                          }}
                        />
                      </div>
                    </div>
                  }
                </li>
                {otpReceived && otp != null && (
                  <li className="h-48 flex cursorPoi flex-center flex-middle">
                    <div
                      onClick={e => {
                        btnHandler(e, 'Fetch Trip')
                      }}
                    >
                      <p
                        className={`f3 ${otp ? 'c-secondary-500' : 'c-neutral-400'
                          }`}
                      >
                        Confirm
                      </p>
                    </div>
                  </li>
                )}
                <li
                  className="flex cursorPoi flex-between flex-middle"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  <If condition={otpError}>
                    <div
                      className="px-4 py14 c-error bg-error flex align-center flex-middle"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      <span>
                        <Info fill="#ce3434" />
                      </span>
                      <p
                        className="pl8 fs-13"
                        style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                      >
                        Incorrect OTP entry. Please try again, or tap "Resend
                        OTP" for a new OTP
                      </p>
                    </div>
                  </If>
                </li>
              </If>
            </ul>
            {showSnackBar && (
              <div id="snackBar" className="bg-black br-8 mx10 bottomMessage">
                <p className="f2 lh-16 py14 c-white px-4">{snackMsg}</p>
              </div>
            )}
          </SectionBlock>
          <div className="pt13 fs-13 px16">
            <span>
              Or{' '}
              <a
                className="c-pointer c-secondary-500"
                onClick={e => {
                  signHandle(e)
                }}
              >
                Sign in
              </a>{' '}
              to fetch your trips
            </span>
          </div>
          {!(params.source === 'home' && params.isMobileApp === 'true') && (
            <section
              className="pt30"
              style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
            >
              <div
                className="flex flex-center"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <div
                  className="faq-bar pb-4"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  <div
                    className="flex flex-center flex-middle px-2 py-1"
                    style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                  >
                    <p
                      className="pl-2 color-8a  f4"
                      style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                    >
                      Frequently asked questions
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="px-4 py-4"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <p
                  className="c-neutral-900 f4 fSemiBold"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  Flight cancellation{' '}
                </p>
                <div className="pt8" />
                <ul
                  className="c-secondary-500 f3 c-pointer"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  <li>
                    <a
                      href="/faq/flights/index.shtml#cancel_booking"
                      target="_blank"
                    >
                      How do I cancel a flight booking?
                    </a>
                  </li>
                </ul>
              </div>
              <div
                className=""
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              />
              <div
                className="px-4 py-4"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <p
                  className="c-neutral-900 f4 fSemiBold"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  Flight reschedule{' '}
                </p>
                <div className="pt8" />
                <ul className="c-secondary-500 f3 c-pointer">
                  <li>
                    <a href="/faq/flights/" target="_blank">
                      How do I make changes to flight reservation?
                    </a>
                  </li>
                  <li className="pt8" />
                  {/* <li>How do I only to cancel only a part of my booking?</li> */}
                </ul>
              </div>
              <div
                className="leftWidget px-4"
                style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
              >
                <p
                  className="c-neutral-900 f4 fSemiBold"
                  style={{ WebkitUserSelect: 'auto', userSelect: 'auto' }}
                >
                  Hotel{' '}
                </p>
                <div className="pt8" />
                <ul className="c-secondary-500 f3 c-pointer pb-4">
                  <li>
                    <a href="/faq/hotels/" target="_blank">
                      Click here for Hotel FAQ's
                    </a>
                  </li>
                  <li className="pt10" />
                  {/* <li><a href="faq/hotels/" target="_blank">I want to confirm my hotel booking status, how do I do that?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">What is my check in time at the hotel?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">What are the cancellation charges for a hotel booking?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">Help! My booking was denied by the hotel!</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">I need to make a change to my hotel booking, how do I do that?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">I would like to make a special request for my booking, how can I do that?</a></li>
              <li className="pt10" />
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">Our children will be travelling with us - do they stay for free?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">Do I need to show ID proof when I check in at the hotel?</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">My refund was initiated, but I haven't received it yet.</a></li>
              <li className="pt10" />
              <li><a href="faq/hotels/" target="_blank">I was unhappy with the hotel's service.</a></li> */}
                </ul>
              </div>
              {/* <FAQContainer data={faq} type="collapse" isPWA={true} /> */}
            </section>
          )}
        </div>
        <If condition={page}>
          {showUnifiedLogin ? (
            <ViewContainer
              page={page}
              isPwa={true}
              isShowing={isShowing}
              toggle={toggle}
              handleIsShowing={handleIsShowing}
              abLogin={abLogin}
              showFkSSO={showFkSSO}
              showFkSSOPwa={showFkSSOPwa}
            />
          ) : (
            <Login
              page={page}
              isShowing={isShowing}
              toggle={toggle}
              handleIsShowing={handleIsShowing}
            />
          )}
        </If>
      </div>}
     
    </React.Fragment>
  )
}
export default SupportPWAPage
